import { render, staticRenderFns } from "./PlayerListPage.vue?vue&type=template&id=f48deb34&scoped=true"
import script from "./PlayerListPage.vue?vue&type=script&lang=js"
export * from "./PlayerListPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerListPage.vue?vue&type=style&index=0&id=f48deb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48deb34",
  null
  
)

export default component.exports